module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "calendar-item swiper-slide",
    attrs: {
      "to": {
        name: 'single',
        params: {
          language: _vm.language,
          slug: _vm.item.slug
        }
      }
    }
  }, [_c('div', {
    staticClass: "large-numeral secondary-color light"
  }, [_vm._v(_vm._s(_vm.item.date))]), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
    staticClass: "date small-text secondary-color bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.nl.day))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.nl.month))])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "date small-text secondary-color bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.en.day))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.en.month))])]) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
    staticClass: "calendar-description small-text secondary-color",
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "calendar-description small-text secondary-color",
    domProps: {
      "innerHTML": _vm._s(_vm.item.title_en)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26cea30a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsCalendarItem.vue
// module id = 214
// module chunks = 2